import {AgentView} from '@ozark/common';
import {EquipmentExpenseResiduals, Loading} from '@ozark/common/components';
import {getChildAgentsByUid, getGroupAgents} from '@ozark/common/hooks/useAgents';
import {useEffect, useState} from 'react';
import {useStore} from '../../store/helpers';

const EquipmentExpensePage = () => {
  const {authProfile, isUserGroupAdmin, isUserMember} = useStore();
  const [agents, setAgents] = useState<AgentView[]>([]);

  const isMember = isUserMember();
  const isAdmin = isUserGroupAdmin();
  const canViewAgents = isAdmin || (isMember && authProfile.data?.subAgentUids?.length > 0);

  useEffect(() => {
    if (authProfile.data) {
      /* If it's a group admin, group agents' residuals are available for viewing */
      if (isAdmin) {
        const {group} = authProfile.data ?? {};
        if (group?.id) {
          getGroupAgents(group.id).then(agents => {
            if (agents?.length) {
              setAgents(agents);
            }
          });
        }
      }
      /* If it's a member and a master agent, sub agents' residuals are available for viewing */
      if (isMember) {
        const {id, subAgentUids} = authProfile.data ?? {};
        if (id && subAgentUids?.length > 0) {
          getChildAgentsByUid(id).then(agents => {
            if (agents?.length) {
              setAgents([authProfile.data as AgentView, ...agents]);
            }
          });
        }
      }
    }
  }, [authProfile.data, isAdmin, isMember]);

  if (authProfile.promised) return <Loading />;

  return (
    <EquipmentExpenseResiduals
      agents={agents ?? []}
      canViewAgents={canViewAgents}
      isAgentNameShown={isAdmin}
    />
  );
};

export default EquipmentExpensePage;
